import React, { useRef } from 'react';
import { Button, Loading, Tag } from 'carbon-components-react';
import { DocumentBlank16, Upload16 } from '@carbon/icons-react';

interface UploadedFileRowProps {
  filename: string;
  metadata: string;
  badge?: string;
  onReplace: () => void;
  onFileSelected?: (file: File) => void;
  accept?: string;
  loading?: boolean;
  disabled?: boolean;
}

const UploadedFileRow: React.FC<UploadedFileRowProps> = ({
  filename,
  metadata,
  badge,
  onReplace,
  onFileSelected,
  accept,
  loading = false,
  disabled = false
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (onFileSelected && inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.click();
    } else {
      onReplace();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && onFileSelected) {
      onFileSelected(file);
    }
  };

  return (
    <div className="uploaded-file-row">
      <div className="uploaded-file-row__left">
        <div
          className={`uploaded-file-row__icon-slot${
            loading ? '' : ' uploaded-file-row__icon-slot--document'
          }`}
        >
          {loading ? (
            <Loading withOverlay={false} small />
          ) : (
            <DocumentBlank16 className="uploaded-file-row__document-icon" />
          )}
        </div>
        <div className="uploaded-file-row__details">
          <div className="uploaded-file-row__filename">
            {filename}
            {badge && <Tag type="green">{badge}</Tag>}
          </div>
          <div className="uploaded-file-row__metadata">{metadata}</div>
        </div>
      </div>
      {onFileSelected && (
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
      )}
      <Button
        kind="secondary"
        size="small"
        renderIcon={Upload16}
        onClick={handleClick}
        disabled={disabled || loading}
      >
        Replace file
      </Button>
    </div>
  );
};

export default UploadedFileRow;
